import { useEffect, useState } from 'react';
import Color from 'color';
import { useSelector } from 'react-redux';

export const deviceSizes = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  desktop: 2560,
};

const useTheme = () => {
  const { innerWidth } = window;
  const [width, setInnerWidth] = useState(innerWidth);
  const [theme, setTheme] = useState({
    sizes: {
      width: 0,
      isMobile: width < deviceSizes.tablet,
      isTablet: width >= deviceSizes.tablet && width < deviceSizes.laptop,
      isComputer: width >= deviceSizes.laptop,
      isLargeComputer: width >= deviceSizes.laptopL,
    },
    primaryColour: '#14435B',
    secondaryColour: '#1b678e',
    accent: '',
    secondaryAccent: '',
    shouldBeWhiteOnSecondary: false,
    shouldBeWhiteOnAccent: false,
    shouldBeWhiteOnSecondaryAccent: false,
  });

  const organisation = useSelector((state) => {
    const urlOrganisation = state.organisations?.urlOrganisation;
    return state?.user?.organisation || urlOrganisation || {};
  });
  const { primaryColour = '#14435B', secondaryColour = '#1b678e' } = organisation;

  useEffect(() => {
    const updateDimensions = () => {
      const { innerWidth: currentInnerWidth } = window;
      setInnerWidth(currentInnerWidth);
    };

    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  useEffect(() => {
    const isMobile = width < deviceSizes.tablet;
    const isTablet = width >= deviceSizes.tablet && width < deviceSizes.laptop;
    const isComputer = width >= deviceSizes.laptop;
    const isLargeComputer = width >= deviceSizes.laptopL;
    const sizes = {
      isMobile,
      isTablet,
      isComputer,
      isLargeComputer,
      width,
      minStyle: Object.entries(deviceSizes).reduce((curr, [key, val]) => ({ ...curr, [key]: `min-width: ${val}px;` })),
      maxStyle: Object.entries(deviceSizes).reduce((curr, [key, val]) => ({ ...curr, [key]: `max-width: ${val}px;` })),
    };

    const accent = Color(primaryColour).lighten(0.2);
    const secondaryAccent = Color(secondaryColour).lighten(0.6).fade(0.8);

    setTheme({
      primaryColour,
      secondaryColour: secondaryColour || primaryColour,
      accent: accent.hex(),
      secondaryAccent: secondaryColour ? secondaryAccent.hex() : accent.hex(),
      shouldBeWhiteOnSecondary: Color(secondaryColour).isDark(),
      shouldBeWhiteOnPrimary: Color(primaryColour).isDark(),
      shouldBeWhiteOnAccent: accent.isDark(),
      shouldBeWhiteOnSecondaryAccent: secondaryAccent.isDark(),
      boxShadow: '0.5px 0.5px 2.5px 1px #C0C0C0',
      sizes,
    });
  }, [primaryColour, secondaryColour, width]);

  return theme;
};

export default useTheme;
